// @vendors
const classNames = require('classnames');
const PropTypes = require('prop-types');
const React = require('react');
const ReactDOM = require('react-dom');
// @Components
const { LoadingSection } = require('commonsComponents/loadingSection');
const ChatMessage = require('./message/ChatMessage');
// @utilities
const { formatText } = require('core/i18n').i18n;
// @constants
const {
    CHAT_CONVERSATION_STATUS: {
        ACTIVE,
        CONNECTING,
        DISCONNECTED,
        ERROR,
        INACTIVE
    }
} = require('constants/chat');

const {
    CHAT_SENDER_TYPE : {
        AGENT,
        MESSAGE_TYPE,
        TYPE
    }
} = require('constants/chat');

require('./ChatMessages.scss');

class ChatMessages extends React.Component {
    constructor(props) {
        super(props);

        this.setRefMessages = this.setRefMessages.bind(this);
    }

    componentDidMount() {
        this.scrollToBottom();
        const { addWelcomeMessage, userFirstName, messages } = this.props;
        const message = {
            from: {type: AGENT},
            index: 0,
            messageType: MESSAGE_TYPE,
            text: formatText('chat-welcomeMessage', [userFirstName]),
            type: TYPE
        };
        (messages.size === 0) && addWelcomeMessage(message);
    }

    componentDidUpdate(prevProps) {
        const { messages } = this.props;
        if (prevProps.messages.size < messages.size) {
            this.scrollToBottom();
        }
    }

    setRefMessages(el) {
        this.chatMessages = el;
    }

    scrollToBottom () {
        const messagesContainer = ReactDOM.findDOMNode(this.chatMessages);
        messagesContainer.scrollTop = messagesContainer.scrollHeight;
    }

    showContentMessages() {
        const { conversationStatus } = this.props;
        let response = null;

        switch (conversationStatus) {
            case CONNECTING:
                response = this.renderConnecting();
                break;
            case ACTIVE:
            case DISCONNECTED:
            case INACTIVE:
                response = this.renderMessages();
                break;
        }
        return response;
    }

    renderConnecting() {
        return (
            <div className="chat-messages__wrapper-loading">
                <LoadingSection />
            </div>
        );
    }

    renderMessages() {
        const { messages, userAvatar, userFirstName } = this.props;
        const userFirstLetter = userFirstName && userFirstName.trim()[0] || '';
        return messages.map((message, index) => (
            <ChatMessage
                key={index}
                immMessage={message}
                userAvatar={userAvatar}
                userFirstLetter={userFirstLetter}
            />
        ));
    }

    render() {
        const { conversationStatus } = this.props;
        const contentMessages = this.showContentMessages();
        const messagesClass = classNames('chat-messages', `chat-messages--${conversationStatus.toLowerCase()}`);
        return (
            <div className={messagesClass} ref={this.setRefMessages}>{contentMessages}</div>
        );
    }
}

ChatMessages.propTypes = {
    addWelcomeMessage: PropTypes.func.isRequired,
    conversationStatus: PropTypes.oneOf([
        ACTIVE,
        CONNECTING,
        DISCONNECTED,
        ERROR,
        INACTIVE
    ]).isRequired,
    messages: PropTypes.object.isRequired,
    userAvatar: PropTypes.object,
    userFirstName: PropTypes.string.isRequired
};

module.exports = ChatMessages;